import React, { useMemo, useState } from 'react'
import Logo from '../../components/logo'
import { Button, Form, Input, Select, Upload, notification } from 'antd'
import { CiHome, CiMail, CiMap, CiMapPin, CiPhone } from 'react-icons/ci'
import { LuFileUp } from 'react-icons/lu'
import { usePostInsurance } from '../../hooks/auth/authentications'
import { useSearchParams } from 'react-router-dom'
import { useGetSubscriptions } from '../../hooks/insuredCompany/insuredCompany'
import countries from '../../nigerian_states.json';

const CreateInsurance = () => {
  const [form] = Form.useForm()
  const [image, setImage] = useState({})
  const [states, setStates] = useState([])
  const [cities, setCities] = useState([])
  
  const [params] = useSearchParams()
  const email = params.get("email")

  const uploadProps = useMemo(() => ({
    name: 'file',
    method: 'GET',
    multiple: false,
    data: image?.file,
    // fileList={} isImageUrl={} previewFile={} 
    onChange({file, fileList}) {
      setImage({
        file,
        name: file?.name,
        fileObj: file?.originFileObj,
        url: URL.createObjectURL(file?.originFileObj),
      })
    }
  }), [image]);

  
  const {
    data: getData,
  } = useGetSubscriptions(
    { subscriptionType: 'Insurance'},
    ["subscriptionType"],
  )

//   const filteredData = getData?.data?.filter((dat) => {
//     return dat.type === 'Insurance';
// });

  const { mutate: postAction, isLoading: postLoad } = usePostInsurance()


  const onSubmit = (d) => {
    const {password, confirm_password: password2} = d

    if(password !== password2){
      notification.warning({
        message: "Password doesn't match",
        description: "please make sure password is correct and matches."
      })
    }

    if (!image?.fileObj) {
      notification.error({
        message: "Failed!",
        description: "Please Image is Required",
      })
    }else{
      const payload = {
        EmailAddress: d.EmailAddress,
        PhoneNumber: d.PhoneNumber,
        imageUrl:  image?.fileObj,
        companyName: d.CompanyName,
        houseNumber: d.houseNumber,
        address:  d.address,
        Password: d.password,
        city: d.city,
        state: d.state,
        country: d.country,
        subscriptionId:  d.subscriptionId,
      }
      postAction(payload)
    }
  }
  const country = countries.country

  return (
    <div className='w-full h-screen flex justify-center items-center bg-blue py-10 sm:p-10 md:px-20 space-y-5'>
      <div className='w-full md:w-[80%] lg:w-[70%] mx-auto py-10 space-y-5 bg-white rounded-xl md:shadow-md'>
        <div className='mt-6'>
          <Logo />
        </div>
        <div className='w-full text-secondary px-5 md:px-14 space-y-10'>
          <div className='text-center space-y-2'>
            <p className='text-2xl font-bold text-light_red'>Rigester your Company account</p>
            <p className='text-sm font-medium text-silver'>Please enter your company credentials here to complete the registration.</p>
          </div>
          <Form 
            form={form} 
            onFinish={onSubmit} 
            // initialValues={{deviceToken: "8880"}} 
            layout='vertical' 
            className='space-y-2'
          >
          <div className='grid grid-cols-1 md:grid-cols-2 gap-5'>
            <Form.Item name="CompanyName">
              <Input placeholder='Company Name' size='large' required type='text' prefix={<CiHome />} />
            </Form.Item>
            <Form.Item name="EmailAddress" initialValue={email}>
              <Input placeholder='Company Email' size='large' required type='email' prefix={<CiMail />} />
            </Form.Item>
          </div>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-5'>
            <Form.Item name="PhoneNumber">
              <Input placeholder='Company contact number' required prefix={<CiPhone />} />          
            </Form.Item>
            <Form.Item name="houseNumber">
              <Input placeholder='Company house number' required />          
            </Form.Item>
          </div>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-5'>
            <Form.Item name="country">
              <Select 
                size='large' 
                placeholder='Select Country'
                onChange={(value) => setStates(country.find((c) => c.name === value)?.states)}
              >
                {country?.map((e)=>(
                  <Select.Option key={e.name} value={e.name}>{e.name}</Select.Option>
                ))}
              </Select>          
            </Form.Item>
            <Form.Item name="state">
              <Select 
                size='large' 
                placeholder='Select State'
                onChange={(value) => setCities(states?.find((c) => c.name === value)?.cities)}
              >
                {states?.map((e)=>(
                  <Select.Option key={e.name} value={e.name}>{e.name}</Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-5'>
            <Form.Item name="city">
              {/* <Input placeholder='City located' required prefix={<CiMapPin />} /> */}
              <Select 
                size='large' 
                placeholder='Select city'
              >
                {cities?.map((e)=>(
                  <Select.Option key={e.name} value={e.name}>{e.name}</Select.Option>
                ))}
              </Select>          
            </Form.Item>
            <Form.Item name="address">
              <Input placeholder='Company address' required prefix={<CiMap />} />          
            </Form.Item>
          </div>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-5'>
            <Form.Item name="subscriptionId">
              {/* <Input placeholder='Subscription Type' required /> */}
              <Select 
                size='large'
                placeholder='Select Subscription Type'
              >
              {getData?.data?.map((e)=>(
                <Select.Option key={e.id} value={e.id}>{e.title}</Select.Option>
              ))}
              </Select>
            </Form.Item>
            <Form.Item name="imageUrl">
              <Upload {...uploadProps}>
                <Button block className='!bg-none text-secondary' icon={<LuFileUp className='text-light_blue' />} type='text' size='large'>Upload Image</Button>
              </Upload>
            </Form.Item>
          </div>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-5'>
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: 'Please input password!',
                },
              ]}
            >
              <Input.Password placeholder="password" />
            </Form.Item>

            <Form.Item
              name="confirm_password"
              rules={[
                {
                  required: true,
                  message: 'Please input password confirmation!',
                },
              ]}
            >
              <Input.Password placeholder="confirm password" />
            </Form.Item>
          </div>
            <Button loading={postLoad} block className='bg-light_red hover:!bg-blue' size='large' type='primary' htmlType='submit'>
              Submit
            </Button>
          </Form>
        </div>
      </div>
    </div>
  )
}

export default CreateInsurance